// Copyright 2019 Sorama B.V.

import { NotificationUrgency } from "services/Notification/INotificationService";
import { IWorkflowModuleNotification, IWorkflowModuleNotificationInstance } from "../Interfaces/IWorkflowModule";

export class WorkflowModuleNotification implements IWorkflowModuleNotification {
    public urgency: NotificationUrgency = NotificationUrgency.Info;
    public message = "";
    public lock = false;
    public buttons: { text: string; callback: () => void }[] = [];
    public closeCallbacks: (() => void)[] = [];

    constructor(
        private showCallback: (notification: WorkflowModuleNotification) => WorkflowModuleNotificationInstance
    ) {}

    public withUrgency(urgency: NotificationUrgency): IWorkflowModuleNotification {
        this.urgency = urgency;
        return this;
    }

    public withMessage(message: string): IWorkflowModuleNotification {
        this.message = message;
        return this;
    }

    public lockModule(lock = true): IWorkflowModuleNotification {
        this.lock = lock;
        return this;
    }

    public withButton(name: string, callback?: () => void): IWorkflowModuleNotification {
        this.buttons.push({ text: name, callback: callback });
        return this;
    }

    public whenClosed(callback: () => void): IWorkflowModuleNotification {
        this.closeCallbacks.push(callback);
        return this;
    }

    public show(): IWorkflowModuleNotificationInstance {
        return this.showCallback(this);
    }
}

export class WorkflowModuleNotificationInstance implements IWorkflowModuleNotificationInstance {
    constructor(public notification: WorkflowModuleNotification) {}

    public close(): void {
        if (this.notification.closeCallbacks) {
            for (const callback of this.notification.closeCallbacks) {
                callback();
            }
        }
    }
}
